import React from 'react';
import { cn } from '../../lib/utils';

export function DenseTable({ columns, data, onRowClick, className, emptyMessage = "No data available", rowClassName }) {
  return (
    <div className={cn("overflow-auto", className)}>
      <table className="dense-table">
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx} className={col.className}>
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center text-muted-foreground py-8">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            data.map((row, rowIdx) => (
              <tr 
                key={row.id || rowIdx} 
                onClick={() => onRowClick?.(row)}
                className={cn(
                  onRowClick && "cursor-pointer",
                  rowClassName && (typeof rowClassName === 'function' ? rowClassName(row) : rowClassName)
                )}
              >
                {columns.map((col, colIdx) => (
                  <td 
                    key={colIdx} 
                    className={cn(
                      col.cellClassName,
                      col.type === 'number' && 'text-right',
                      col.type === 'profit' && (row[col.accessor] >= 0 ? 'profit' : 'loss')
                    )}
                  >
                    {col.render ? col.render(row) : row[col.accessor]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
